import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-environment roba-container flex flex-align-start" }
const _hoisted_2 = { class: "my-environment__menu white flex flex-column mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenuItems, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "roboto-slab",
          to: item.route,
          key: item.route.name
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(item.title)), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _createVNode(_component_router_view)
  ]))
}